import { render, staticRenderFns } from "./Titulo.vue?vue&type=template&id=83b7f52e&scoped=true&"
import script from "./Titulo.vue?vue&type=script&lang=js&"
export * from "./Titulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b7f52e",
  null
  
)

export default component.exports